type VideoPlatforms = 'youtube' | 'vimeo';

export default function detectPlatform(videoUrl: string): VideoPlatforms {
  if (videoUrl.includes('vimeo')) {
    return 'vimeo';
  }
  return 'youtube';
}
